<template>
  <div class="contact">
    <a-form ref="formRef" :model="modelForm" layout="vertical" @finish="onFinish">
      <a-form-item
        class="form-item-label"
        name="first_name"
        label="First name"
        :rules="[{ required: true, message: 'This field is required' }]"
      >
        <a-input
          v-model:value="modelForm.first_name"
          :maxlength="40"
          class="overseas-contact-form__input"
          size="large"
          placeholder="Enter Your First Name"
        />
      </a-form-item>
      <a-form-item
        class="form-item-label"
        name="last_name"
        label="Last name"
        :rules="[{ required: true, message: 'This field is required' }]"
      >
        <a-input
          v-model:value="modelForm.last_name"
          :maxlength="40"
          class="overseas-contact-form__input"
          size="large"
          placeholder="Enter Your Last Name"
        />
      </a-form-item>
      <a-form-item
        class="form-item-label"
        name="business_email"
        label="Business email"
        :rules="[
          { required: true, message: 'This field is required' },
          {
            pattern: emailReg,
            message: 'Add a valid email',
            trigger: 'blur',
          },
        ]"
      >
        <a-input
          v-model:value="modelForm.business_email"
          class="overseas-contact-form__input"
          size="large"
          placeholder="Enter Your Business email"
        ></a-input>
      </a-form-item>
      <a-form-item
        class="form-item-label"
        name="company_name"
        label="Company Name"
        :rules="[
          {
            required: true,
            message: 'This field is required',
          },
        ]"
      >
        <a-textarea
          v-model:value="modelForm.company_name"
          :maxlength="100"
          show-count
          :autosize="{
            minRows: 3,
            maxRows: 3,
          }"
          placeholder="Enter Your Company Name"
        />
      </a-form-item>
      <!-- </div> -->
      <a-form-item
        class="form-item-hightlight"
        name="company_size"
        label="Company Size"
        :rules="[{ required: true, message: 'This field is required' }]"
      >
        <a-select
          v-model:value="modelForm.company_size"
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          class="overseas-contact-form__select"
          size="large"
          placeholder="Please choose company size"
          :options="
            params?.company_size?.map(item => ({
              value: item.id,
              label: item.value,
            }))
          "
        ></a-select>
      </a-form-item>
      <a-form-item
        class="form-item-hightlight"
        :class="{ 'mb-[16px]': modelForm.department === VALUE_OTHER }"
        name="department"
        label="Which department are you in?"
        :rules="[{ required: true, message: 'This field is required' }]"
      >
        <a-select
          v-model:value="modelForm.department"
          class="overseas-contact-form__select"
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          size="large"
          placeholder="Please select your department"
        >
          <a-select-option
            v-for="item in params?.department"
            :key="item.id"
            class="pb-[8px]"
            :value="item.id"
          >
            {{ item.value }}
          </a-select-option>
          <a-select-option class="pb-[8px]" :value="VALUE_OTHER">
            {{ $t('qi-ta') }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="modelForm.department === VALUE_OTHER" name="other_department">
        <a-textarea
          v-model:value="modelForm.other_department"
          :maxlength="100"
          show-count
          :autosize="{
            minRows: 3,
            maxRows: 3,
          }"
          placeholder="Enter Your Other Department"
        />
      </a-form-item>
      <a-form-item
        class="form-item-hightlight"
        :class="{ 'mb-[16px]': modelForm.use_case === VALUE_OTHER }"
        name="use_case"
        label="Your video use case"
        :rules="[{ required: true, message: 'This field is required' }]"
      >
        <a-select
          v-model:value="modelForm.use_case"
          class="overseas-contact-form__select"
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          size="large"
          placeholder="Please select your use case"
        >
          <a-select-option
            v-for="item in params?.use_case"
            :key="item.id"
            class="pb-[8px]"
            :value="item.id"
          >
            {{ item.value }}
          </a-select-option>
          <a-select-option class="pb-[8px]" :value="VALUE_OTHER">
            {{ $t('qi-ta') }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="modelForm.use_case === VALUE_OTHER" name="other_use_case">
        <a-textarea
          v-model:value="modelForm.other_use_case"
          :maxlength="100"
          show-count
          :autosize="{
            minRows: 3,
            maxRows: 3,
          }"
          placeholder="Enter Your Other Use Case"
        />
      </a-form-item>
      <a-form-item class="form-item-label" name="message" label="Message">
        <a-textarea
          v-model:value="modelForm.message"
          :maxlength="1000"
          show-count
          :autosize="{
            minRows: 3,
            maxRows: 3,
          }"
          placeholder="Enter Your Message"
        />
      </a-form-item>
      <a-form-item class="text-center">
        <a-button
          type="primary"
          size="large"
          class="overseas-contact-form__submit"
          html-type="submit"
        >
          Submit
        </a-button>
        <!-- <a-button style="margin-left: 10px">Cancel</a-button> -->
      </a-form-item>
    </a-form>
  </div>
</template>
<script lang="ts" setup>
import type { FormInstance } from 'ant-design-vue';
import type { ContactEnAddRequest, ContactEnData } from '~/api/interface';
const { $t } = useNuxtApp();

interface ContactProps {
  params: ContactEnData | undefined;
}
defineProps<ContactProps>();
const emit = defineEmits(['submit']);
const VALUE_OTHER = 0;
const formRef = ref<FormInstance>();

const modelForm = reactive<ContactEnAddRequest>({
  first_name: '',
  last_name: '',
  business_email: '',
  company_name: '',
  department: undefined,
  company_size: undefined,
  other_department: '',
  use_case: undefined,
  other_use_case: '',
  message: '',
});

const onFinish = (values: ContactEnAddRequest) => {
  emit('submit', values);
};
</script>
<style lang="scss" scoped>
@use '@rendora/design/styles/mixins.scss' as *;

.contact {
  @apply mx-auto py-[24px];

  .form-item-label {
    // 覆盖 form-item label
    :deep(.ant-form-item-label > label) {
      @apply text-font-1 font-semibold text-[16px];
      color: inherit;
    }
  }

  .form-item-hightlight {
    :deep(.ant-form-item-label > label) {
      @apply text-font-1 font-semibold text-[16px];
    }
  }
}

.overseas-contact-form {
  &__input {
    @apply w-[578px];

    @include mobile {
      @apply w-full;
    }
  }

  &__select {
    @apply w-[360px];

    @include mobile {
      @apply w-full;
    }
  }

  &__submit {
    @apply w-[390px];

    @include mobile {
      @apply w-full;
    }
  }
}
</style>
